import { render, staticRenderFns } from "./MAM_setRate.vue?vue&type=template&id=4205a516&scoped=true&"
import script from "./MAM_setRate.vue?vue&type=script&lang=js&"
export * from "./MAM_setRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205a516",
  null
  
)

export default component.exports